import { SvgIconType } from '@ahc-digital/component-library';
import { N07CorporateFooterProps } from './N07CorporateFooter.types';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { IMAGE_ASSET_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function CreateCorporatefooterModel(props?: N07CorporateFooterProps) {
  const { renderLink } = useConditionalRendering();

  return {
    socialMediaLinks: props?.fields?.SocialMediaLinks?.map((item) => {
      const link = item?.fields?.Link?.value;
      const socialMediaType = item?.fields?.Type?.fields?.Value?.value as SvgIconType;
      const capitalizedSocialMediaType =
        socialMediaType.charAt(0).toUpperCase() + socialMediaType.slice(1);

      return {
        link: (
          <a
            href={`${link?.href}`}
            target={`${link?.target}`}
            title={`${capitalizedSocialMediaType}`}
            aria-label={`${capitalizedSocialMediaType}`}
          />
        ),
        iconName: socialMediaType,
      };
    }),
    footerBody: props?.rendering && (
      <Placeholder name={IMAGE_ASSET_CARDS} rendering={props.rendering} />
    ),
    copyRightText: props?.fields?.CopyrightText?.value?.replace(
      /{year}/,
      new Date().getFullYear().toString()
    ),
    legalPrivacyLink: renderLink(props?.fields?.LegalAndPrivacyLink),
  };
}
